import { msg } from '@lingui/core/macro';

export const SHARED_CARD_INFO_DUE = msg`Due`;
export const SHARED_CARD_INFO_VALID_UNTIL = msg`Valid until`;
export const SHARED_CARD_INFO_COMPLETED = msg`Completed`;
